import { render } from "./BaseCard.vue?vue&type=template&id=3eb53314&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=3eb53314&scoped=true&lang=css"

import exportComponent from "/Users/klausdresbach/Dropbox/IT-Projekte/Web-Entwicklung/niceplaces/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb53314"]])

export default __exports__